export default __webpack_public_path__ + "static/media/guide@3x.c047ddd7.webp";